export enum SettingKeyEnum {
  KM_OR_MILES = 'km_or_miles',
  RECORDING_ACCURACY = 'recordingAccuracy',
  SHOW_WELCOME_SCREEN = 'showWelcomeScreen'
}
